module.exports = __webpack_public_path__ + "img/creamy-mobile.689e2e33.webp";